import pushToDataLayer from "./pushToDataLayer";
import itemDataTemplate from "./itemDataTemplate";
import { CURRENCY_CODE } from "./constants";

const viewItemListEvent = (
  items,
  { itemListName = "wishlist", recommendationsRequestId } = {}
) => {
  const localCurrencyCode = items[0]?.price.currency;

  pushToDataLayer({
    view_item_list: {
      item_list_name: itemListName,
      ...(recommendationsRequestId && {
        recommendations_request_id: recommendationsRequestId
      }),
      ecommerce: {
        currency: CURRENCY_CODE,
        localCurrencyCode,
        items: items.map((item, index) => itemDataTemplate(item, index))
      }
    }
  });
};

export default viewItemListEvent;
